import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from '../../../_services/contact.service';
import { CompanyService } from '../../../_services/company.service';

@Component({
  selector: 'app-new-contact',
  templateUrl: './new-contact.component.html',
  styleUrls: ['./new-contact.component.css']
})
export class NewContactComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_contact: boolean = false;
  private add_company = false;
  constructor(private service: ContactService, private company_service: CompanyService) { }

  new_contact = new FormGroup({
    email: new FormControl(''),
    company: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('')
  });

  new_company = new FormGroup({
    email: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('')
  });

  ngOnInit() {
    jQuery('#add-contact-modal #company-input').dropdown({ placeholder: 'value' });
  }

  openModal() {
    jQuery('#add-contact-modal').modal({ inverted: true, allowMultiple: true }).modal('show');
  }

  newCompany(name) {
    this.new_company.patchValue({ name: name });
    this.add_company = true;
  }

  // New Contact
  submitContactForm() {
    this.new_contact.disable();   // Disable the form to avoid changes during the Creation process
    this.creating_contact = true; // Trigger the Loading button apparition
    jQuery('#add-contact-modal').modal({ closable: false }); // Set the modal unclosable during the creation process   

    if (this.add_company) {
      this.new_company.disable();
      this.company_service.createCompany(this.new_company.value) // Create the Contact
        .subscribe(response => {
          this.new_contact.patchValue({ company: response.id });
          this.createContact();
        });
    } else {
      this.createContact();
    }
  }

  createContact() {
    this.service.createContact(this.new_contact.value) // Create the Contact
      .subscribe(response => {
        jQuery('#add-contact-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
        this.add_company = false;
        this.new_company.enable();
        this.creating_contact = false; // Disable the loading button apparition
        this.new_contact.enable(); // Re Enable the Form
        this.new_contact.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/contact/new-contact/new-contact.component.ts